module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hollandsnieuwe-02@2x.11ecb95a.jpg";